const root = (state) => state.vacation;

export const vacationDataSelector = (state) => root(state).vacationDetails;
